// Auth
export const SIGN_IN = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";

// Cart
export const CART_ADD = "CART_ADD";
export const CART_REMOVE = "CART_REMOVE";
